import { useShallow } from 'zustand/react/shallow';
import { useAccount } from '../account/store.ts';
import { services } from '../services/index.ts';

/** Personal vs org workspace (scope) for the library and new projects. */
export function WorkspaceSwitcher({ className = '' }: { className?: string }) {
  const { me, activeScope } = useAccount(useShallow((s) => ({ me: s.me, activeScope: s.activeScope })));
  if (!me || me.orgs.length === 0) return null;
  return (
    <label className={`flex items-center gap-2 ${className}`}>
      <span className="sr-only">Workspace</span>
      <select
        aria-label="Workspace"
        className="t-label h-9 max-w-[200px] rounded-md border border-border bg-surface2 px-2"
        value={activeScope ?? me.personalScope}
        onChange={(e) => services.account.setActiveScope(e.target.value)}
      >
        <option value={me.personalScope}>Personal</option>
        {me.orgs.map((o) => (
          <option key={o.id} value={o.id}>
            {o.name}
          </option>
        ))}
      </select>
    </label>
  );
}
